import React from "react";

import AlternativeName from "../../../../../../../components/AlternativeName";
import { SwitchBoxField } from "../../../../../../../../../components/forms/fields";

import NameSelectField from "./NameSelectField";

const Form = ({ formProps: { values } }) => (
    <>
        <NameSelectField />

        {
            values.name === "other" && (
                <AlternativeName/>
            )
        }

        <SwitchBoxField
            label='Is Required'
            name="isRequired"
        />

        <SwitchBoxField
            label='Prepend domain name normalizer'
            name="prependDomainNameNormalizer"
        />

        <SwitchBoxField
            label='Remove get parameters normalizer'
            name="removeGetParametersNormalizer"
        />
    </>
);

export default Form;
